import { Navigate, useLocation } from 'react-router';

/** Step 17e: /platform/… is now Super Admin's /admin/… (Companies became Organisations). */
export function PlatformRedirect() {
  const { pathname, search } = useLocation();
  const rest = pathname.replace(/^\/platform\/?/, '').replace(/^companies/, 'organisations');
  return <Navigate to={`/admin/${rest}${search}`} replace />;
}
